export const selectBonusesState = (state) => state.bonuses;

export const selectBonusesInfo = (state) => state.bonuses?.info || null;

export const selectPointsActive = (state) => state.bonuses?.info?.wallet_points_active || 0;

// available_to_spend не используем — источник истины по доступным баллам это wallet_points_active
export const selectAvailableToSpend = (state) => state.bonuses?.info?.wallet_points_active || 0;

export const selectIsBonusesLoading = (state) => state.bonuses?.loading || false;

export const selectIsBonusesApplying = (state) => state.bonuses?.applying || false;

export const selectBonusesError = (state) => state.bonuses?.error || null;

export const selectBonusCoupon = (state) => state.bonuses?.coupon || null;

export const selectIsBonusApplied = (state) => state.bonuses?.isApplied || false;

export const selectBonusDiscount = (state) => state.bonuses?.discount || 0;

export const selectBonusAppliedCartTotal = (state) => state.bonuses?.appliedCartTotal || 0;

export const bonusesSelectors = {
    selectBonusesState,
    selectBonusesInfo,
    selectPointsActive,
    selectAvailableToSpend,
    selectIsBonusesLoading,
    selectIsBonusesApplying,
    selectBonusesError,
    selectBonusCoupon,
    selectIsBonusApplied,
    selectBonusDiscount,
    selectBonusAppliedCartTotal,
};

export default bonusesSelectors;
